import VueI18n from "vue-i18n"
import Vue from "vue"
import en from "@/locales/en/en.json"
import de from "@/locales/de/de.json"
import es from "@/locales/es/es.json"
import pt from "@/locales/pt/pt.json"
import getLocale from "@/utils/locale"
import { SanitiserFormatter } from "@/modules/i18nSanitiseFormatter"
import { sharedConfig } from "@blinkist/web-component-library"

Vue.use(VueI18n)

export default new VueI18n({
  locale: getLocale(),
  fallbackLocale: "en",
  formatter: new SanitiserFormatter(),
  dateTimeFormats: sharedConfig.dateTimeFormats,
  messages: {
    en: { ...en, ...sharedConfig.messages.en },
    de: { ...de, ...sharedConfig.messages.de },
    es: { ...es, ...sharedConfig.messages.es },
    pt: { ...pt, ...sharedConfig.messages.pt }
  }
})
